var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6708 0.251007H13.4226C13.2476 0.251007 13.0815 0.331364 12.9744 0.468864L5.61188 9.79565L2.08152 5.32244C2.02811 5.25463 1.96004 5.1998 1.88241 5.16207C1.80478 5.12434 1.71962 5.10468 1.6333 5.10458H0.385089C0.265447 5.10458 0.199375 5.24208 0.272589 5.33494L5.16366 11.5314C5.39223 11.8207 5.83152 11.8207 6.06188 11.5314L14.7833 0.479579C14.8565 0.388507 14.7904 0.251007 14.6708 0.251007Z",
    fill: "#00A9CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.6b9f2531f7b07f5a00a43e5e5eb9a476.svg";
export { ForwardRef as ReactComponent };